<template>
  <div class="aside-bar-super">
    <div class="aside-item" title="编辑" @click="handleItem('editor')">
      <SvgIcon class="icon" icon-class="zs-tj-edit" />
      <span>编辑</span>
    </div>
    <div class="aside-item" title="编辑live2d" @click="handleItem('live2d')">
      <SvgIcon class="icon" icon-class="zs-tj-edit" />
      <span>live2d</span>
    </div>
    <div class="aside-item" title="编辑服装" @click="handleItem('cloth')">
      <SvgIcon class="icon" icon-class="zs-tj-edit" />
      <span>服装</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import eventBus from "@/plugins/eventBus";

export default {
  name: "AsideBarSuper",
  props: { detail: { type: Object, default: () => ({}) } },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  methods: {
    handleItem(type) {
      if (type === "editor") {
        this.$router.push(
          `/${this.gameInfo.alias}/rich-table?id=${this.detail.id}&entry_id=${this.detail.entry_id}&title=${this.detail.title}`
        );
      } else if (type === "live2d") {
        eventBus.$emit("live2dPosition");
      } else if (type === "cloth") {
        eventBus.$emit("editCloth");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.aside-bar-super {
  display: flex;
  column-gap: 20px;
  .aside-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    color: #a8b9bf;
    font-size: 12px;
    line-height: 12px;
    transition: all ease 0.3s;
    cursor: pointer;
    .icon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
